import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Empty } from "antd";

import LectureSetDetails from "./LectureSetDetails";
import ModuleDetails from "./ModuleDetails";
import ProblemSetDetails from "./ProblemSetDetails";

/**
 * Renders the detail view for whichever tree node is selected. `onBack`,
 * when provided, renders a back-to-tree button above the detail view — this
 * only happens on the mobile master/detail flow, never on desktop.
 * @param {{
 *   selectedNode: object|null,
 *   refreshContentTree: () => void,
 *   courseEducators: object[],
 *   lectureTypes: string[],
 *   ROOT_URL: string,
 *   BASE_URL: string,
 *   adminConfig: object,
 *   onBack?: () => void
 * }} props
 */
const ContentPanel = ({
  selectedNode,
  refreshContentTree,
  courseEducators = [],
  lectureTypes = [],
  ROOT_URL,
  BASE_URL,
  adminConfig,
  onBack
}) => {
  if (!selectedNode) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%"
        }}
      >
        <Empty description="Select a module to view details" />
      </div>
    );
  }

  let detail = <div>Unknown Node Type</div>;

  if (selectedNode.type === "MODULE") {
    detail = (
      <ModuleDetails
        moduleData={selectedNode}
        refreshContentTree={refreshContentTree}
        ROOT_URL={ROOT_URL}
        BASE_URL={BASE_URL}
        adminConfig={adminConfig}
      />
    );
  } else if (selectedNode.type === "LECTURE_SET") {
    detail = (
      <LectureSetDetails
        lectureSetData={selectedNode}
        courseEducators={courseEducators}
        lectureTypes={lectureTypes}
        refreshContentTree={refreshContentTree}
        ROOT_URL={ROOT_URL}
        BASE_URL={BASE_URL}
        adminConfig={adminConfig}
      />
    );
  } else if (selectedNode.type === "PROBLEM_SET") {
    detail = (
      <ProblemSetDetails
        problemSetData={selectedNode}
        refreshContentTree={refreshContentTree}
        ROOT_URL={ROOT_URL}
        BASE_URL={BASE_URL}
        adminConfig={adminConfig}
      />
    );
  }

  return (
    <div>
      {onBack && (
        <Button icon={<ArrowLeftOutlined />} onClick={onBack} style={{ marginBottom: 16 }}>
          All Modules
        </Button>
      )}
      {detail}
    </div>
  );
};

export default ContentPanel;
